import * as Yup from 'yup';

const ERR_MSG = {
  SELECT_REGISTER: 'Selecione um cadastro',
  REQUIRED: 'Campo obrigatório',
  TYPE_NUMBER: 'Informe um número válido',
  TYPE_DATE: 'Informe uma data válida',
  MIN_VALUE: 'O valor não pode ser menor que 0',
  MIN_LENGTH_11: 'O campo deve ter 11 posições numéricas',
  DURATION_GT_PUBLICATION:
    'Data de início da vigência deve ser maior ou igual a data de publicação',
  DUE_GT_PUBLICATION: 'Data de vencimento deve ser maior que a data de publicação',
  maxValueMessage: length => `O campo deve ter no máximo ${length} caracteres.`,
};

export const manageLineValidationSchema = Yup.object().shape({
  nuLinha: Yup.string().required(ERR_MSG.REQUIRED),
  deOrigem: Yup.string().required(ERR_MSG.REQUIRED),
  deDestino: Yup.string().required(ERR_MSG.REQUIRED),
  cdCategoria: Yup.string().required(ERR_MSG.REQUIRED),
  cdSubSistema: Yup.string().required(ERR_MSG.REQUIRED),
  cdLinhaOutorga: Yup.string().required(ERR_MSG.REQUIRED),
  cdTipoVeiculo: Yup.string().required(ERR_MSG.REQUIRED),
  cdMunicipioPolo: Yup.string().required(ERR_MSG.REQUIRED),
  cdLinhaServico: Yup.string().required(ERR_MSG.REQUIRED),
  deDescricao: Yup.string().required(ERR_MSG.REQUIRED),
  nuPermissionarios: Yup.number()
    .min(0, ERR_MSG.MIN_VALUE)
    .required(ERR_MSG.REQUIRED),
  nuEdital: Yup.string().required(ERR_MSG.REQUIRED),
});

export const manageLineStripValidationSchema = Yup.object().shape({
  nuLinha: Yup.string().required(ERR_MSG.REQUIRED),
  deOrigem: Yup.string().required(ERR_MSG.REQUIRED),
  deDestino: Yup.string().required(ERR_MSG.REQUIRED),
  deDescricao: Yup.string().required(ERR_MSG.REQUIRED),
  deRazaoSocial: Yup.string().required(ERR_MSG.REQUIRED),
  cdLinhaOutorga: Yup.string().required(ERR_MSG.REQUIRED),
  nuTermoContrato: Yup.string().required(ERR_MSG.REQUIRED),
  dtTermoContrato: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  cdOrgaoTermoContrato: Yup.string().required(ERR_MSG.REQUIRED),
  cdLinhaServico: Yup.string().required(ERR_MSG.REQUIRED),
  cdCategoria: Yup.string().required(ERR_MSG.REQUIRED),
  cdTipoVeiculo: Yup.string().required(ERR_MSG.REQUIRED),
  cdSubSistema: Yup.string().required(ERR_MSG.REQUIRED),
});

export const activationLineValidationSchema = Yup.object().shape({
  deMotivo: Yup.string().required(ERR_MSG.REQUIRED),
});

export const activationPermissionaryValidationSchema = Yup.object().shape({
  deMotivo: Yup.string().required(ERR_MSG.REQUIRED),
});

export const newFareValidationSchema = Yup.object().shape({
  nuValor: Yup.number()
    .typeError(ERR_MSG.TYPE_NUMBER)
    .min(0, ERR_MSG.MIN_VALUE)
    .required(ERR_MSG.REQUIRED),
  dtEmissao: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  nuProcesso: Yup.string()
    .typeError(ERR_MSG.REQUIRED)
    .required(ERR_MSG.REQUIRED),
});

export const permissionariesValidationSchema = Yup.object().shape({
  deNomePermissionario: Yup.string()
    .typeError(ERR_MSG.REQUIRED)
    .required(ERR_MSG.REQUIRED),
  nuTermo: Yup.string()
    .typeError(ERR_MSG.REQUIRED)
    .required(ERR_MSG.REQUIRED),
  dtAssinatura: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  cdLinhaOutorga: Yup.string()
    .typeError(ERR_MSG.REQUIRED)
    .required(ERR_MSG.REQUIRED),
  dtPublicacao: Yup.date()
    .default(null)
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  dtInicioVigencia: Yup.date()
    .default(null)
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED)
    .when('dtPublicacao', (dtPublicacao, schema) => {
      return dtPublicacao && !isNaN(dtPublicacao.getDay())
        ? schema.min(dtPublicacao, ERR_MSG.DURATION_GT_PUBLICATION)
        : schema;
    }),
  dtVencimento: Yup.date()
    .default(null)
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED)
    .when('dtPublicacao', (dtPublicacao, schema) => {
      if (!!dtPublicacao && !isNaN(dtPublicacao.getDay())) {
        let dt = new Date(dtPublicacao.toISOString());
        dt.setDate(dt.getDate() + 1);
        return schema.min(dt, ERR_MSG.DUE_GT_PUBLICATION);
      } else {
        return schema;
      }
    }),
  cdPermissionarioRefData: Yup.string()
    .typeError(ERR_MSG.REQUIRED)
    .required(ERR_MSG.REQUIRED),
  deCnh: Yup.number()
    .min(11, ERR_MSG.MIN_LENGTH_11)
    .typeError(ERR_MSG.TYPE_NUMBER)
    .required(ERR_MSG.REQUIRED),
  tpCategoriaCnh: Yup.string()
    .typeError(ERR_MSG.REQUIRED)
    .required(ERR_MSG.REQUIRED),
  nuPrazo: Yup.string()
    .typeError(ERR_MSG.REQUIRED)
    .required(ERR_MSG.REQUIRED),
  deTipoPrazo: Yup.string()
    .typeError(ERR_MSG.REQUIRED)
    .required(ERR_MSG.REQUIRED),
});

export const permissionariesAddictivesValidationSchema = Yup.object().shape({
  nuAditivo: Yup.string()
    .max(10, ERR_MSG.maxValueMessage(10))
    .required(ERR_MSG.REQUIRED),
  cdTipoDocumento: Yup.string()
    .typeError(ERR_MSG.REQUIRED)
    .required(ERR_MSG.REQUIRED),
  dtEmissao: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  dtPublicacao: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
});

export const itinerariesValidationSchema = Yup.object().shape({
  dtCadastro: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  cdTipoItinerario: Yup.string().required(ERR_MSG.REQUIRED),
  deObservacao: Yup.string(),
  cdLinhaSituacao: Yup.string().required(ERR_MSG.REQUIRED),
});

export const scheduleValidationSchema = Yup.object().shape({
  nuProcesso: Yup.string().required(ERR_MSG.REQUIRED),
  dtCadastro: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  dtVigencia: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED)
    .when('dtCadastro', (dtCadastro, schema) => {
      if (!!dtCadastro && !isNaN(dtCadastro.getDay())) {
        let dt = new Date(dtCadastro.toISOString());
        dt.setDate(dt.getDate() - 1);
        return schema.min(dt, 'Data de vigência deve ser maior ou igual a data de cadastro');
      } else {
        return schema;
      }
    }),
  cdLinhaSituacao: Yup.string().required(ERR_MSG.REQUIRED),
  deObservacao: Yup.string(),
});

export const transferValidationSchema = Yup.object().shape({
  nuTermoPermissao: Yup.string().required(ERR_MSG.REQUIRED),
  nuTermoTransferencia: Yup.string().required(ERR_MSG.REQUIRED),
  dtPublicacao: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  dtVigencia: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  dtTransferencia: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
});

export const transferStripValidationSchema = Yup.object().shape({
  nuProcesso: Yup.string().required(ERR_MSG.REQUIRED),
  deCnpj: Yup.string().required(ERR_MSG.REQUIRED),
  deRazaoSocial: Yup.string().required(ERR_MSG.REQUIRED),
  nuTermoTransferencia: Yup.string().required(ERR_MSG.REQUIRED),
  dtAssinatura: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  dtPublicacao: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
});

export const conductorsValidationSchema = Yup.object().shape({
  nuProcesso: Yup.string().required(ERR_MSG.REQUIRED),
  deNome: Yup.string().required(ERR_MSG.REQUIRED),
  deCpf: Yup.string().required(ERR_MSG.REQUIRED),
  deCnh: Yup.number()
    .min(11, ERR_MSG.MIN_LENGTH_11)
    .typeError(ERR_MSG.TYPE_NUMBER)
    .required(ERR_MSG.REQUIRED),
  tpCategoriaCnh: Yup.string().required(ERR_MSG.REQUIRED),
  dtEmissao: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  dtValidade: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED)
    .when('dtEmissao', (dtEmissao, schema) => {
      if (!!dtEmissao && !isNaN(dtEmissao.getDay())) {
        let dt = new Date(dtEmissao.toISOString());
        dt.setDate(dt.getDate() - 1);
        return schema.min(dt, 'Data de validade deve ser maior ou igual a data de emissão');
      } else {
        return schema;
      }
    }),
});

export const apostillesValidationSchema = Yup.object().shape({
  nuProcesso: Yup.string().required(ERR_MSG.REQUIRED),
  deBaseLegal: Yup.string().required(ERR_MSG.REQUIRED),
  deAditamento: Yup.string().required(ERR_MSG.REQUIRED),
  dePublicacao: Yup.string().required(ERR_MSG.REQUIRED),
  dtEmissao: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  dtInicioValidade: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
});

export const contractValidationSchema = Yup.object().shape({
  deRazaoSocial: Yup.string().required(ERR_MSG.REQUIRED),
  cdTipoContrato: Yup.string().required(ERR_MSG.REQUIRED),
  cdOrgao: Yup.string().required(ERR_MSG.REQUIRED),
  cdTipoServico: Yup.string().required(ERR_MSG.REQUIRED),
  nuTermo: Yup.string().required(ERR_MSG.REQUIRED),
  dtInicioVigencia: Yup.date().nullable().typeError(ERR_MSG.TYPE_DATE),
  dtVencimento: Yup.date().nullable().typeError(ERR_MSG.TYPE_DATE)
    .when('dtInicioVigencia', (dtInicioVigencia, schema) => {
    if (!!dtInicioVigencia && !isNaN(dtInicioVigencia.getDay())) {
      let dt = new Date(dtInicioVigencia.toISOString());
      dt.setDate(dt.getDate() - 1);
      return schema.min(dt, 'Data de vencimento deve ser maior ou igual a data de inicio da vigência');
    } else {
      return schema;
    }
  }),
  dtAssinatura: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
  dtPublicacao: Yup.date()
    .typeError(ERR_MSG.TYPE_DATE)
    .required(ERR_MSG.REQUIRED),
});
